import React from "react"

export function PostalGradientBar() {
  return (
    <div className="h-[100px] w-full bg-gradient-to-r from-postal-gradient-start to-postal-gradient-end" />
  )
}
